export const MIN_REFUND_AMOUNT = 50;

export const REQUEST_REFUND_EXPIRED_DAYS = 7;
